module.exports = __webpack_public_path__ + "img/piggy.05932263.svg";